import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledAmountInput = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 20px;
  width: 100%;
  border-width: 1px;
  border-style: solid;
  border-radius: ${themeGet('radii.base')};
  border-color: ${themeGet('colors.text.border')};

  &:not(:last-child) {
    margin-bottom: 6px;
  }

  &.is--error {
    border-color: ${themeGet('colors.input.textError')};
  }

  button {
    padding: 5px 9px;
    outline: none;
    line-height: 16px;
    text-transform: uppercase;
    background-color: transparent;
    border-width: 1px;
    border-style: solid;
    color: ${themeGet('colors.primary.extra')};
    font-size: ${themeGet('fontSizes.xs')}px;
    font-weight: ${themeGet('fontWeights.semi')};
    border-color: ${themeGet('colors.text.border')};
    border-radius: ${themeGet('radii.base')};

    &:hover {
      color: ${themeGet('colors.white')};
      background-color: ${themeGet('colors.text.border')};
    }
  }
`;

export const StyledAmount = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const StyledError = styled.span`
  color: ${themeGet('colors.input.textError')};
  font-size: ${themeGet('fontSizes.xs')}px;
  font-weight: ${themeGet('fontWeights.regular')};

  b {
    font-weight: ${themeGet('fontWeights.semi')};
  }
`;

type TextProps = {
  right?: boolean;
};

export const StyledBottomText = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

export const StyledTopText = styled.span<TextProps>`
  display: flex;
  align-items: center;
  align-self: ${(props) => (props?.right ? 'flex-end' : 'flex-start')};
  margin-bottom: ${(props) => (props?.right ? '0' : '3px')};
  line-height: 16px;
  color: ${themeGet('colors.text.default')};
  font-size: ${themeGet('fontSizes.xs')}px;
  font-weight: ${themeGet('fontWeights.semi')};

  svg {
    margin-right: 7px;
  }
`;

export const StyledSign = styled.span`
  display: flex;
  align-items: center;
  font-size: ${themeGet('fontSizes.up')}px;
  font-weight: ${themeGet('fontWeights.bold')};
  color: ${themeGet('colors.text.default')};

  svg {
    margin-right: 20px;
  }
`;
